import {Price, Typography} from '@bonprix/design-system';
import {Touchpoint} from './ProductCard.jsx';
import ProductCardBenefits from './ProductCardBenefits.jsx';
import {NEITHER_IN_TAB_NOR_IN_ARROW_ORDER} from '../../hooks/useGroupedFocus.js';

export default function ProductCardHeader({touchpoint, item, texts, onItemClick, isMobile, useDesyPriceComponent}) {

    const isAddToCartTouchPoint = touchpoint === Touchpoint.ADD_TO_CART_SHEET;
    const wrappingClassToUseForTitle = isAddToCartTouchPoint || isMobile ? "two-line-wrap" : "nowrap";

    let priceComponentObject = {
        currentPrice: 0.00,
        amount: 1,
        isFromPrice: false,
        oldPrice: 0.00,
        showUnits: false,
        size: "small",
        variant: "regular",
        uniquePrice: false
    };

    const populatePriceComponentValues = () => {

        priceComponentObject.currentPrice = parseFloat(item.price);

        let variant = "regular";
        if (item.formerPrice) {
            variant = "sale";
            priceComponentObject.oldPrice = parseFloat(item.formerPrice);
        } else if (item.bestPriceDeviationPercent < 0) {
            variant = "best-price";
            priceComponentObject.oldPrice = parseFloat(item.bestPriceValue);
        }
        priceComponentObject.variant = variant;

        if (isAddToCartTouchPoint && item.pricePerItem && item.packItemsCount > 1) {
            priceComponentObject.showUnits = true;
            priceComponentObject.amount = item.packItemsCount;
        }
        priceComponentObject.uniquePrice = item.uniquePrice;
        return priceComponentObject;
    }

    if (useDesyPriceComponent) {
        priceComponentObject = populatePriceComponentValues();
    }

    let pricePerItemBlock = null;
    if(isAddToCartTouchPoint && item.pricePerItem && item.packItemsCount > 1) {
        pricePerItemBlock = (
            <div className={'product-card__price-per-item'}>
                <Typography component="span" variant="body2" color="on-bg-low">
                    {item.packItemsCount} {texts.au_piece}
                </Typography>
                <Typography component="span" variant="body2" color="on-bg-low">
                    |
                </Typography>
                <Typography component="span" variant="body2" color="on-bg-low">
                    {item.pricePerItem} {texts.au_unit_price}
                </Typography>
            </div>
        );
    }

    return (
        <div className={`product-card__header touchpoint-${touchpoint}`}>

            {touchpoint !== Touchpoint.RECOMMENDATION && <ProductCardBenefits benefits={item.benefits} />}

            <Typography variant="h6" component="span">
                <a className={`product-card__link ${wrappingClassToUseForTitle}`} href={item.productLink} onClick={onItemClick} tabIndex={NEITHER_IN_TAB_NOR_IN_ARROW_ORDER}>
                    {item.title}
                </a>
            </Typography>

            <div className={`product-card_price-section ${touchpoint}-touchpoint`}>
                {useDesyPriceComponent ? (
                        <Price
                            currentPrice={priceComponentObject.currentPrice}
                            isFromPrice={!priceComponentObject.uniquePrice}
                            size={priceComponentObject.size}
                            variant={priceComponentObject.variant}
                            showUnits={priceComponentObject.showUnits}
                            amount={priceComponentObject.amount}
                            oldPrice={priceComponentObject.oldPrice}
                        />
                    )
                    :
                    (
                        <>
                            <div className={'product-card__price'}>
                                <Typography variant={touchpoint  === Touchpoint.RECOMMENDATION || touchpoint === Touchpoint.ADD_TO_CART_SHEET ? 'h6' : 'h4'} component="span" color={item.formerPrice ? "sale" : ""} >
                                    {item.price}
                                </Typography>
                                {item.formerPrice &&
                                    <>
                                        <Typography strikeThrough variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? "h6" : "body2"} component="span" color="on-bg-mid">
                                                <span className="product-card__previous-price">
                                                    {item.formerPrice}
                                                </span>
                                        </Typography>
                                        <Typography variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? "h6" : "body2"} component="span" color="sale">
                                            {item.pricePercentageReduction}
                                        </Typography>
                                    </>
                                }
                            </div>
                            {pricePerItemBlock}
                        </>
                    )
                }
            </div>

            {touchpoint === Touchpoint.RECOMMENDATION && <ProductCardBenefits benefits={item.benefits} />}

        </div>
    )
}
